import { createAuthenticatedApiInstance } from 'src/utils/api';
import actionTypes from './actionTypes';
import { setAlert } from 'src/modules/shared/alert/actions';
import * as log from 'loglevel';
import fundraiser from 'src/modules/programs/shared/constants/fundraiser';

export const unenrollFromProgram = (programSlug, userId) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.UNENROLL_FROM_PROGRAM });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.del(`private/programs/${programSlug}/subscribe?user-id=${userId}`);
      dispatch({
        type: actionTypes.UNENROLL_FROM_PROGRAM_SUCCESS,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({
        type: actionTypes.UNENROLL_FROM_PROGRAM_FAILURE,
        error: ex,
      });
      dispatch(setAlert(ex.message));
    }
  };
};

export const enrollForProgram = (programSlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.ENROLL_FOR_PROGRAM });
    try {
      let userId;
      if (getState().context.currentUser.userId) {
        userId = getState().context.currentUser.userId;
      } else {
        throw Error('Sign up or login to enroll');
      }
      const api = createAuthenticatedApiInstance(getState);
      await api.post(`private/programs/${programSlug}/subscribe?user-id=${userId}`);
      dispatch({
        type: actionTypes.ENROLL_FOR_PROGRAM_SUCCESS,
      });
      dispatch(fetchModules(programSlug, userId));
    } catch (ex) {
      log.error(ex);
      dispatch({
        type: actionTypes.ENROLL_FOR_PROGRAM_FAILURE,
        error: ex,
      });
    }
  };
};

export const fetchProgram = (programSlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PROGRAM_DETAILS });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.getPublic(`programs/${programSlug}`);
      const { data: enrolledUsers } = await api.getPublic(`programs/${programSlug}/total-enrolled`);
      data.headerLink = {
        as: `/programs/${programSlug}`,
        href: `/programs/program?programSlug=${programSlug}`,
      };

      dispatch({
        type: actionTypes.FETCH_PROGRAM_DETAILS_SUCCESS,
        program: data,
        totalEnrolledUsers: enrolledUsers.totalEnrolled,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({
        type: actionTypes.FETCH_PROGRAM_DETAILS_FAILURE,
        error: ex,
      });
    }
  };
};

export const fetchFundraiser = (programSlug) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_PROGRAM_OVERVIEW_FUNDRAISER });
    try {
      dispatch({
        type: actionTypes.FETCH_PROGRAM_OVERVIEW_FUNDRAISER_SUCCESS,
        fundraiser: fundraiser[programSlug] || {},
      });
    } catch (ex) {
      log.error(ex);
      dispatch({
        type: actionTypes.FETCH_PROGRAM_OVERVIEW_FUNDRAISER_FAILURE,
        error: ex,
      });
    }
  };
};

export const toggleModuleOpenStatus = moduleSort => {
  return {
    type: actionTypes.TOGGLE_MODULE_OPEN_STATUS,
    moduleSort,
  };
};

export const fetchUnenrolledModules = (programSlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PROGRAM_MODULES_UNENROLLED });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.getPublic(`programs/${programSlug}/modules`);
      dispatch({
        type: actionTypes.FETCH_PROGRAM_MODULES_UNENROLLED_SUCCESS,
        programModules: data,
        isSubscribed: false,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({
        type: actionTypes.FETCH_PROGRAM_MODULES_UNENROLLED_FAILURE,
        error: ex,
      });
      dispatch(setAlert(ex.message));
    }
  };
};

const calculateUserProgress = modules => {
  const sectionsLength = [];
  const completedSections = [];
  const sum = (a, b) => a + b;

  modules.map(module => {
    sectionsLength.push(module.sections.length);
    completedSections.push(module.sections
      .map(section => section.isCompleted ? 1 : 0)
      .reduce(sum, 0));
  });
  return 100 * completedSections.reduce(sum, 0) / sectionsLength.reduce(sum, 0);
};

export const fetchModules = (programSlug, userId) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PROGRAM_MODULES });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.get(`private/programs/${programSlug}/modules?user-id=${userId}`);
      const progress = calculateUserProgress(data.modules);

      if (data.isSubscribed) {
        dispatch({
          type: actionTypes.FETCH_PROGRAM_MODULES_ENROLLED_SUCCESS,
          programModules: data.modules,
          isSubscribed: true,
          progress,
        });
      } else {
        dispatch({
          type: actionTypes.FETCH_PROGRAM_MODULES_UNENROLLED_SUCCESS,
          programModules: data.modules,
          isSubscribed: false,
        });
      }
    } catch (ex) {
      log.error(ex);
      dispatch({
        type: actionTypes.FETCH_PROGRAM_MODULES,
        error: ex,
      });
      dispatch(setAlert(ex.message));
    }
  };
};

export const showProgramSummary = () => {
  return {
    type: actionTypes.SHOW_PROGRAM_ABOUT,
  };
};

export const setEnrollHoverState = (isHovering) => {
  return {
    type: actionTypes.TOGGLE_ENROLL_ICON_HOVER,
    isEnrolledIconHovered: isHovering,
  };
};



// WEBPACK FOOTER //
// ./src/modules/programs/overview/actions.js